import { useContext } from "react";
import { GoogleCalendarContext, GoogleCalendarContextType } from "./googleCalendarContextDef";

export const useGoogleCalendar = (): GoogleCalendarContextType => {
  const context = useContext(GoogleCalendarContext);
  if (context === undefined) {
    throw new Error("useGoogleCalendar must be used within a GoogleCalendarProvider");
  }
  return context;
};
